import { createElement } from 'react'

import { PlateLeaf, createPlatePlugin } from 'platejs/react'
import type { AnyPlatePlugin, PlateLeafProps } from 'platejs/react'

import styles from './characterLimitHighlight.module.css'

export const CHARACTER_LIMIT_HIGHLIGHT_KEY = 'character-limit-highlight'

// Not returned directly from the arrow function: an explicit return type on
// the expression itself back-propagates into createPlatePlugin's own
// generic inference and corrupts it (options/node end up typed against the
// annotation's defaults instead of the literal passed in).
export const createCharacterLimitHighlightPlugin = (): AnyPlatePlugin => {
  const plugin = createPlatePlugin({
    key: CHARACTER_LIMIT_HIGHLIGHT_KEY,
    node: {
      isLeaf: true,
      component: (props: PlateLeafProps) =>
        createElement(PlateLeaf, {
          ...props,
          className: styles.highlight,
        }),
    },
  })
  return plugin
}
